import { createBrowserHistory, createMemoryHistory } from 'history';
import { connectRouter, routerMiddleware } from 'connected-react-router';

export const history = window ? createBrowserHistory() : createMemoryHistory();
export const historyRouter = connectRouter(history);
export const historyMiddleware = routerMiddleware(history);
